import updateProfile from './updateProfile';
import convertToProfileView from './convertToProfileView';

export default (path, version = 'v1', namespace = 'afosto') => async views => {
  try {
    const tenantViews = views.filter(view => view.type !== 'user' && view.active);
    const promises = tenantViews.map(tenantView => {
      const profileKey = tenantView.key.replace(/^(me.|tenant.)/, '');
      return updateProfile(
        `${namespace}.tenant.${path}.${version}.views.${profileKey}`,
        convertToProfileView(tenantView),
      );
    });

    return Promise.resolve(promises);
  } catch (err) {
    return Promise.reject(err);
  }
};
